import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { BaseView, BaseText } from '@/components/base'
import { Toggle, StickyHeaderNavigation } from '@/components'
import useOffsets from '@/hooks/useOffsets'

export const NotificationsSettingsScreen: React.FC = () => {
  const { t } = useTranslation()
  const offsets = useOffsets()

  const [isReceiveTextNotifications, setIsReceiveTextNotifications] =
    useState(false)
  const [isReceiveEmailNotifications, setIsReceiveEmailNotifications] =
    useState(false)

  return (
    <BaseView flex={1} bgColor="background.screen" className="h-full">
      {/* Fixed Header Navigation */}
      <StickyHeaderNavigation
        title={t('notificationsSettings.notifications')}
      />

      {/* Scrollable Content */}
      <BaseView
        flex={1}
        px={12}
        style={{
          overflowY: 'auto',
          paddingBottom: '40px',
          paddingTop: offsets.top + 40,
        }}
      >
        <BaseView gap={20} mt={20}>
          {/* Text Notifications Row */}
          <BaseView
            row
            align="center"
            justify="space-between"
            // py={12}
            rounded={16}
          >
            <BaseText fontSize={16} fontFamily="semibold" color="label.default">
              {t('notificationsSettings.textNotifications')}
            </BaseText>

            <Toggle
              isActive={isReceiveTextNotifications}
              onToggle={setIsReceiveTextNotifications}
            />
          </BaseView>

          {/* Email Notifications Row */}
          <BaseView
            row
            align="center"
            justify="space-between"
            // px={16}
            // py={12}
            rounded={16}
          >
            <BaseText fontSize={16} fontFamily="semibold" color="label.default">
              {t('notificationsSettings.emailNotifications')}
            </BaseText>

            <Toggle
              isActive={isReceiveEmailNotifications}
              onToggle={setIsReceiveEmailNotifications}
            />
          </BaseView>
        </BaseView>
      </BaseView>
    </BaseView>
  )
}

export default NotificationsSettingsScreen
